module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"label":"Meniu","menu":{"solarPlantChoices":["Namams","Verslui","Saulės parkai"],"top":["Saulės elektrinės","Geriausios kainos garantija","Finansavimas","Įgyvendinti projektai","Apie mus","Kontaktai","Gaukite pasiūlymą"]}}}')
  delete Component.options._Ctor
}
